var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.805,
    height: 17.679,
    viewBox: "0 0 12.805 17.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-icon",
    transform: "translate(-70.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12283",
    "data-name": "Group 12283",
    transform: "translate(70.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37875",
    "data-name": "Path 37875",
    d: "M76.976,0a6.41,6.41,0,0,0-6.4,6.4c0,4.381,5.73,10.813,5.974,11.085a.577.577,0,0,0,.858,0c.244-.272,5.974-6.7,5.974-11.085A6.41,6.41,0,0,0,76.976,0Zm0,9.624A3.221,3.221,0,1,1,80.2,6.4,3.225,3.225,0,0,1,76.976,9.624Z",
    transform: "translate(-70.573)",
    fill: "#1768d6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.b7548175.svg";
export { ForwardRef as ReactComponent };